export function createCustomTypeFilter(
  values?: (string | number)[],
  predefinedTypeFieldName = 'type',
  customTypeName = 'custom',
  customTypeIdFieldName = 'custom_type_id'
) {
  if (!values) {
    return []
  }

  const customEventTypeIds: number[] = []
  const predefinedEventTypeNames: string[] = []

  let hasNull = false

  for (const eventType of values) {
    if (eventType === null) {
      hasNull = true
    } else if (typeof eventType === 'number') {
      customEventTypeIds.push(eventType)
    } else {
      predefinedEventTypeNames.push(eventType)
    }
  }

  const combinedFilter: string[] = []

  if (hasNull) {
    combinedFilter.push(`${predefinedTypeFieldName}.is.null`)
  }
  if (predefinedEventTypeNames.length > 0) {
    combinedFilter.push(
      `${predefinedTypeFieldName}.in.(${predefinedEventTypeNames
        .map((option) => `"${option}"`)
        .join(',')})`
    )
  }
  if (customEventTypeIds.length > 0) {
    combinedFilter.push(
      `and(type.eq.${customTypeName},${customTypeIdFieldName}.in.(${customEventTypeIds
        .map((option) => `${option}`)
        .join(',')}))`
    )
  }

  return combinedFilter
}
